import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CustomValidators {

  /**空白を除去した上での必須チェックを行う */
  static requiredTrimmed(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value !== 0 && !control.value) {
        return {'required' : 'false'};
      }
      const validate = (String(control.value)).trim();
      return validate.length > 0 ? null : {'required' : 'false'};
    };
  }
}